import { BsTrashFill } from 'react-icons/bs';
import { daysOfTheWeekS, generalHelpers } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction } from 'react';
import { typeMeeting } from '@monorepo/models';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    isEdit: boolean;
    meetings: typeMeeting[];
    setMeetingsToSave: Dispatch<SetStateAction<typeMeeting[] | null>>;
};

export const RoomCleaningTable: FC<propsType> = ({ isEdit, meetings, setMeetingsToSave }) => {
    const config = useGetConfig();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    const getClasses = (i: number): string => {
        if (isDarkMode) {
            if (i % 2) {
                return 'text-white';
            } else {
                return 'bg-lightdark text-white';
            }
        } else {
            if (i % 2) {
                return 'bg-striped';
            } else {
                return '';
            }
        }
    }

    return (
        <div className={`${isEdit ? '' : 'table-responsive'} mt-3`}>
            <table className={`table table-bordered ${isDarkMode ? 'table-dark' : ''} w-100 font-monospace mx-auto`}>
                <thead>
                    <tr>
                        <th colSpan={isEdit ? 1 : 2} className={isDarkMode ? '' : 'bg-striped'}>Fecha</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Día</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Sem</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Año</th>
                        <th colSpan={3} className={isDarkMode ? '' : 'bg-striped'}>Grupos {!isMobile && 'Encargados de la Limpieza'}</th>
                        {isEdit &&
                            <th className={isDarkMode ? '' : 'bg-light'}>Eliminar</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {meetings.map((m, i) =>
                        <tr key={m.id}>
                            <td className={`${getClasses(i)} text-nowrap`}>
                                {isEdit ?
                                    <input type={'date'}
                                        className={'form-control form-control-sm'}
                                        value={m.date}
                                        // onChange={e => {
                                        //     const v = e.target.value;
                                        //     const _year = parseInt(v.split('-')[0]);
                                        //     const _month = parseInt(v.split('-')[1]) - 1;
                                        //     const _day = parseInt(v.split('-')[2]);
                                        //     const date = new Date(_year, _month, _day);
                                        //     setMeetingsToSave(x => x!.map(_m => _m.id === m.id ? ({
                                        //         ..._m,
                                        //         date: v,
                                        //         weekday: date.getDay(),
                                        //         weekNumber: generalHelpers.GetCalendarWeekNumber(date),
                                        //         year: _year
                                        //     }) : _m));
                                        // }}
                                        // disabled={!!m.sections.length}
                                        disabled
                                    />
                                    :
                                    <>{daysOfTheWeekS[m.weekday]}</>
                                }
                            </td>
                            {!isEdit &&
                                <td className={'text-nowrap text-start'}>
                                    {generalHelpers.InvertDateString(m.date)}
                                </td>
                            }
                            <td className={getClasses(i)}>
                                {m.date ? `${daysOfTheWeekS[m.weekday].slice(0, 3)}.` : ''}
                            </td>
                            <td className={getClasses(i)}>
                                {m.weekNumber || ''}
                            </td>
                            <td className={getClasses(i)}>
                                {m.year || ''}
                            </td>
                            <td className={getClasses(i)}>
                                {isEdit ?
                                    <select className={'form-select'}
                                        value={m.groupsForCleaning[0] || ''}
                                        onChange={e => {
                                            const v = parseInt(e.target.value) || 0;
                                            setMeetingsToSave(x => x!.map(_m => _m.id === m.id ? ({
                                                ..._m,
                                                groupsForCleaning: _m.groupsForCleaning.length ?
                                                    _m.groupsForCleaning.map((_g, _i) => _i === 0 ? v : _g)
                                                    :
                                                    [v]
                                            }) : _m));
                                        }}
                                        disabled={!!m.groupsForCleaning.filter((g, _i) => _i < 0 && !g).length  || !!m.groupsForCleaning.filter((g, _i) => _i > 0 && !!g).length}
                                    >
                                        <option value={''}>
                                            {/* Ninguno */}
                                        </option>
                                        {Array.from({ length: config.numberOfGroups}, (_, _i) => _i + 1).map(_g =>
                                            <option key={_g} value={_g} disabled={!!m.groupsForCleaning.includes(_g)}>
                                                Grupo {_g}
                                            </option>
                                        )}
                                    </select>
                                    :
                                    <>{!!m.groupsForCleaning?.[0] ? <>Grupo {m.groupsForCleaning[0]}</> : ''}</>
                                }
                            </td>
                            <td className={getClasses(i)}>
                                {isEdit ?
                                    <select className={'form-select'}
                                        value={m.groupsForCleaning[1] || ''}
                                        onChange={e => {
                                            const v = parseInt(e.target.value) || 0;
                                            setMeetingsToSave(x => x!.map(_m => _m.id === m.id ? ({
                                                ..._m,
                                                groupsForCleaning: _m.groupsForCleaning.length === 2 ?
                                                    _m.groupsForCleaning.map((_g, _i) => _i === 1 ? v : _g)
                                                    :
                                                    [_m.groupsForCleaning[0], v]
                                            }) : _m));
                                        }}
                                        disabled={!!m.groupsForCleaning.filter((g, _i) => _i < 1 && !g).length  || !!m.groupsForCleaning.filter((g, _i) => _i > 1 && !!g).length}
                                    >
                                        <option value={''}>
                                            {/* Ninguno */}
                                        </option>
                                        {Array.from({ length: config.numberOfGroups}, (_, _i) => _i + 1).map(_g =>
                                            <option key={_g} value={_g} disabled={!!m.groupsForCleaning.includes(_g)}>
                                                Grupo {_g}
                                            </option>
                                        )}
                                    </select>
                                    :
                                    <>{!!m.groupsForCleaning?.[1] ? <>Grupo {m.groupsForCleaning[1]}</> : ''}</>
                                }
                            </td>
                            <td className={getClasses(i)}>
                                {isEdit ?
                                    <select className={'form-select'}
                                        value={m.groupsForCleaning[2] || ''}
                                        onChange={e => {
                                            const v = parseInt(e.target.value) || 0;
                                            setMeetingsToSave(x => x!.map(_m => _m.id === m.id ? ({
                                                ..._m,
                                                groupsForCleaning: _m.groupsForCleaning.length === 3 ?
                                                    _m.groupsForCleaning.map((_g, i1) => i1 === 2 ? v : _g)
                                                    :
                                                    [_m.groupsForCleaning[0], _m.groupsForCleaning[1], v]
                                            }) : _m));
                                        }}
                                        disabled={!!m.groupsForCleaning.filter((g, _i) => _i < 2 && !g).length  || !!m.groupsForCleaning.filter((g, _i) => _i > 2 && !!g).length}
                                    >
                                        <option value={''}>
                                            {/* Ninguno */}
                                        </option>
                                        {Array.from({ length: config.numberOfGroups}, (_, _i) => _i + 1).map(_g =>
                                            <option key={_g} value={_g} disabled={!!m.groupsForCleaning.includes(_g)}>
                                                Grupo {_g}
                                            </option>
                                        )}
                                    </select>
                                    :
                                    <>{!!m.groupsForCleaning?.[2] ? <>Grupo {m.groupsForCleaning[2]}</> : ''}</>
                                }
                            </td>
                            {isEdit &&
                                <td className={getClasses(i)}>
                                    {!m.sections.length && !m.avAssignments.some(a => a.user) && !m.usherAssignments.some(a => a.user) &&
                                        <button className={'btn btn-danger btn-sm w-100'}
                                            onClick={() => {
                                                setMeetingsToSave(x => x!.filter(_m => _m.id !== m.id));
                                            }}
                                        >
                                            <BsTrashFill className={'mb-1'} />
                                        </button>
                                    }
                                </td>
                            }
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}
